// extracted by mini-css-extract-plugin
export default {"faqPage":"FAQPage_faqPage__56iPf","row":"FAQPage_row__Xw8XH","column":"FAQPage_column__yf5+f","columns":"FAQPage_columns__-N3kG"};